/**
 * Модель общей информации о уведомлениях
 */
export class NotifyInfoModel {
    hasInvites: boolean;    // Есть ли приглашения в группы/каналы
    unread: {               // Информация о непрочитанных сообщениях
        peers: number;          // Количество непрочитанных сообщений в диалогах
        channels: number;       // Количество непрочитанных сообщений в каналах
        groups: number;         // Количество непрочитанных сообщений в группах
    }
}